export const getSuccessRedirectUrl = (paymentLink) => (
  paymentLink?.success_redirect_url || paymentLink?.redirect_url || null
);

export const getExpiredRedirectUrl = (paymentLink) => (
  paymentLink?.expired_redirect_url || paymentLink?.redirect_url || null
);

export const redirectToMerchantUrl = (redirectUrl) => {
  if (!redirectUrl) {
    return false;
  }

  // Replace the current (SPA) history entry with the app root before leaving.
  // window.location.href is a full-page navigation to a different origin, so we
  // can't trap popstate there like on PaymentSuccess — instead we make sure the
  // entry left behind in browser history already points to "/". That way, if the
  // user hits back from the merchant's redirect URL, the browser lands on "/"
  // instead of reloading back into the payment flow (ThirdForm/SecondForm/etc).
  window.history.replaceState(null, "", "/");
  window.location.href = redirectUrl;
  return true;
};
